import{GetRequest_Email,GetPlataformasMoviles} from './components/serverComponent/python/pythonAxios'
import '@fortawesome/fontawesome-free/css/all.css';



import Swal from 'sweetalert2'

// Fecha en el Copyright
let d = document;
let date = new Date();
let dateFormat = date.getFullYear();
d.querySelector('#elmYear').textContent = dateFormat;

let id_back
let insumos_iniciales

window.onload = () => { 
    let params = new URLSearchParams(location.search);
    id_back = params.get('b');
    sessionStorage.setItem('b',id_back)
}

// insumos iniciales de personalización de plataforma
const Api_inicial = GetPlataformasMoviles('autenticacion/insumos_iniciales/app movil')
Api_inicial.then(res => res.json())
  .then((response) => {
    insumos_iniciales = response
    // //Datos de plataforma
    d.title = insumos_iniciales.PLATAFORMA_NAME + ' | Login'
    d.getElementById('municipio').innerHTML = insumos_iniciales.PLATAFORMA_NAME
    d.getElementById('textoMunicipio').innerHTML = insumos_iniciales.DESCRIPCION
    // //recover pass
    let btn_recover = d.getElementById('back')
    btn_recover.setAttribute('href','login.html?b='+id_back)
    // //Imagenes de plataforma
    let fondo_avif = d.getElementById('fondo_avif')
    fondo_avif.setAttribute('srcset',insumos_iniciales.IMG_FONDO_1)
    let fondo_otro = d.getElementById('fondo_otro')
    fondo_otro.setAttribute('srcset',insumos_iniciales.IMG_FONDO_2)
    let fondo_otros_navegadores = d.getElementById('fondo_otros_nav')
    fondo_otros_navegadores.setAttribute('src',insumos_iniciales.IMG_FONDO_2)
    // //Logo
    let logo_plataforma = d.getElementById('logo-Plataforma')
    logo_plataforma.setAttribute('src',insumos_iniciales.IMG_LOGO)
    if (insumos_iniciales.ALTO_LOGO) { //personalizar alto del logo del login
      if (insumos_iniciales.ALTO_LOGO > 0) {
        logo_plataforma.style.height = insumos_iniciales.ALTO_LOGO+'px'
      }
    }
    //Icono
    let icon = d.createElement('link')
    icon.setAttribute('rel','icon')
    icon.setAttribute('async',true)
    icon.setAttribute('href',insumos_iniciales.IMG_ICO)
    d.head.appendChild(icon)
    //Colores de la plataforma
    let colores = insumos_iniciales.COLORES
    asignarColores(colores)    
})
//

let Botton2 = document.getElementById("recover-password");
Botton2.onclick = recover_password;


function error_message(){
    return Swal.fire({
      title: 'Error!',
      text: 'El Correo Ingresado No Se Encuentra Registrado.',
      icon: 'error',
      confirmButtonText: 'OK'
    });
};

function success_message(){
    return Swal.fire({
      title: 'Verificación Exitosa',
      text: 'Se han enviado las credenciales al correo ingresado.',
      icon: 'success',
      confirmButtonText: 'OK'
    });
};
  

function recover_password(){
    var Email = document.getElementById('check_mail').value;
    console.log(Email)
    if (Email==""){
        document.getElementById("check_mail").focus();
    }
    else{
        const Api_Recover = GetRequest_Email(Email)

        Api_Recover.then((response) => {
            console.log(response.status)
            if(response.status != 200){
                error_message()
            }else{
                return response.json()
            }
       
        })
        .then((response) => {
            console.log(response)
            if (response.status === true){
                success_message()
            }
            else{
                error_message()
            }
        })
        
    }
}

function asignarColores(colores) {
    colores.forEach(color => {
      document.documentElement.style.setProperty('--'+color.uso, color.color);
    });
  }